<template>
  <div class="stat-item">
    <div v-if="fixHeight" class="stat-header">&nbsp;</div>
    <div class="stat-header">
      <span class="stat-label">{{ label }}</span>
      <span v-if="!showPercentage" class="stat-value right">{{ value }}</span>
    </div>
    <div v-if="showDetail || showPercentage" class="stat-header bar-row">
      <div v-if="showDetail">
        <span class="stat-value" :class="valueClass">{{ value }}</span>
        <span class="stat-detail">{{ $t('Webportal.RangeOf') }} {{ total }}</span>
      </div>
      <span v-if="showPercentage" class="stat-percent">{{ percentage }}%</span>
    </div>
    <div class="bar">
      <div class="bar-fill" :class="barColor" :style="{ width: `${percentage}%` }">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BarItem',

  props: {
    label:          { type: String, required: true },
    value:          { type: Number, required: true },
    total:          { type: Number, required: true },
    barColor:       { type: String, default: 'green' },
    valueClass:     { type: String, default: '' },
    showPercentage: { type: Boolean, default: true },
    showDetail:     { type: Boolean, default: true },
    fixHeight:      { type: Boolean, default: false }
  },

  computed: {
    percentage() {
      if (!this.total || this.total === 0) return 0;
      return Math.round((this.value / this.total) * 100);
    }
  }
}
</script>

<style lang="scss" scoped>
.stat-item {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  width: 22%;
}

.stat-header {
  display: flex;
  line-height: 0.9em;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.5rem;
  width: 100%;
}

.stat-left {
  display: flex;
  gap: 0.35rem;
  align-items: baseline;
}

.bar-row {
}

.stat-label {
  font-size: 12px;
  color: var(--bs-secondary-color);
}

.stat-detail {
  font-size: 12px;
  color: var(--bs-secondary-color);
}

.stat-percent {
  font-size: 12px;
  font-weight: 500;
  color: var(--bs-body-color);
}

.stat-value {
  font-size: 12px;
  font-weight: 500;
  color: var(--bs-body-color);

  &.right {
    align-self: flex-end;
    text-align: right;
  }

  &.stat-completed {
    color: var(--default-status-green);
  }

  &.stat-processing {
    color: var(--default-status-yellow);
  }

  &.stat-claimed {
    color: var(--default-status-red);
  }
}

.bar {
  height: 3px;
  background: var(--bs-border-color);
  border-radius: 999px;
  overflow: hidden;
  width: 100%;
  margin-top: 6px;
}

.bar-fill {
  height: 100%;
  width: 0;

  &.red {
    background: var(--default-status-table-bg-red);
  }

  &.yellow {
    background: var(--default-status-table-bg-yellow);
  }

  &.green {
    background: var(--default-status-table-bg-green);
  }
}
</style>
